// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/distress-message-formats.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/distress-message-formats/distress-message-formats.js';

mount([g0]);
